export default "__VITE_ASSET__CnCciUOJ__"